// products.ts
//
// (c) NCR Voyix Corporation 2025. All rights reserved.

import { AuthenticatedUser } from '../common/authenticatedUser'
import { AppError } from '../common/result'
import { get } from '../common/upgradesApiClient'

/**
 * Retrieves all available versions for a particular product
 * @param productId - product ID of desired product for retrieval of all available versions
 * @param companyId - user selected Company ID
 * @param authUser - Basic authenticated user info
 */
export async function getProductVersions(
  productId: string,
  companyId: string,
  stack: string,
  authUser: AuthenticatedUser
): Promise<string[]> {
  const response = await get<string[]>(
    {
      route: `/products/${stack}/${productId}/versions`,
      user: authUser,
      optionalHeaders: {
        companyid: companyId
      }
    }
  )

  if (response instanceof AppError) {
    throw new Error(response.errorMsg)
  }

  return response
}
